import React from "react"
import { Button, Modal, Form } from "react-bootstrap"
import styled from "styled-components"
import POSSaleContext from "../../../context"

const CPFArea = styled.div`
display: flex;
flex-direction: row;
justify-content: space-between;
align-items: center;
padding: 10px 15px;
background: #f8f9fa;
border-radius: 8px;
border: 1px solid #dee2e6;
margin-top: 5px;
`

const CPFAreaIcon = styled.div`
cursor: pointer;
color: #dc3545;
transition: all 0.2s;
&:hover {
    transform: scale(1.1);
    color: #a71d2a;
}
`

const SaveButton = styled(Button)`
    background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
    border: none;
    padding: 10px 25px;
    font-weight: 600;
    letter-spacing: 0.5px;
    box-shadow: 0 4px 6px rgba(0, 123, 255, 0.2);
    transition: all 0.3s ease;
    
    &:hover {
        background: linear-gradient(135deg, #0069d9 0%, #004494 100%);
        box-shadow: 0 6px 12px rgba(0, 123, 255, 0.3);
        transform: translateY(-1px);
    }
    
    &:active {
        transform: translateY(0);
    }
`

const formatCPF = (v) => {
    v = v.replace(/\D/g, "")
    if (v.length <= 11) {
        v = v.replace(/(\d{3})(\d)/, "$1.$2")
        v = v.replace(/(\d{3})(\d)/, "$1.$2")
        v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
    }
    return v
}

export default class POSSaleCPF extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            show: false,
            cpfValue: ""
        }
        this._openModal = this._openModal.bind(this)
        this._closeModal = this._closeModal.bind(this)
        this._saveCPF = this._saveCPF.bind(this)
        this._onChange = this._onChange.bind(this)
        this._removeCPF = this._removeCPF.bind(this)
    }

    _openModal() {
        this.setState({ show: true })
    }

    _closeModal() {
        this.setState({ show: false, cpfValue: "" })
    }

    _onChange(e) {
        this.setState({ cpfValue: formatCPF(e.target.value) })
    }

    _saveCPF() {
        // Remove mapping from format before saving to context
        const rawValue = this.state.cpfValue.replace(/\D/g, "")
        this.props.onSetCPF(rawValue)
        this._closeModal()
    }

    _removeCPF() {
        this.props.removeCPF()
        this.setState({ cpfValue: "" })
    }

    render() {
        return <POSSaleContext.Consumer>
            {
                sale => {
                    const hasCPF = sale.cpf_cnpj
                    return <div className={this.props.className}>
                        {
                            hasCPF
                                ? <CPFArea>
                                    <div>
                                        <p style={{ margin: 0, fontSize: "0.9rem", color: "#6c757d" }}>CPF na Nota</p>
                                        <p style={{ margin: 0, fontWeight: "bold" }}>{formatCPF(hasCPF)}</p>
                                    </div>
                                    <div>
                                        <CPFAreaIcon onClick={this._removeCPF}>
                                            <i
                                                title="Remover CPF"
                                                className="fas fa-trash-alt" />
                                        </CPFAreaIcon>
                                    </div>
                                </CPFArea>
                                : <Button
                                    onClick={this._openModal}
                                    className="w-100 dim py-2"
                                    variant="outline-primary">
                                    CPF na Nota
                                </Button>
                        }
                        <Modal show={this.state.show} onHide={this._closeModal} centered>
                            <Modal.Header closeButton style={{ borderBottom: "none" }}>
                                <Modal.Title style={{ fontWeight: "700", color: "#212529" }}>CPF na Nota</Modal.Title>
                            </Modal.Header>
                            <Modal.Body style={{ paddingTop: "0" }}>
                                <Form.Group>
                                    <Form.Label style={{ fontSize: "0.9rem", color: "#6c757d", marginBottom: "8px" }}>
                                        Informe o CPF do consumidor
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="000.000.000-00"
                                        value={this.state.cpfValue}
                                        onChange={this._onChange}
                                        autoFocus
                                        style={{ 
                                            borderRadius: "8px", 
                                            padding: "12px", 
                                            border: "2px solid #e9ecef" 
                                        }}
                                    />
                                    <Form.Text className="text-muted" style={{ display: "block", marginTop: "10px", fontSize: "0.8rem" }}>
                                        O CPF será incluído na NFC-e sem necessidade de cadastro completo do cliente.
                                    </Form.Text>
                                </Form.Group>
                            </Modal.Body>
                            <Modal.Footer style={{ borderTop: "none", justifyContent: "center", paddingBottom: "25px" }}>
                                <SaveButton onClick={this._saveCPF}>
                                    Salvar CPF
                                </SaveButton>
                            </Modal.Footer>
                        </Modal>
                    </div>
                }
            }
        </POSSaleContext.Consumer>
    }
}



// WEBPACK FOOTER //
// ./src/views/AppViews/POS/components/FooterActionsPOS/SaleCPF/index.jsx